import {theme} from './utils/theme-preval'
import {KeyPaths} from './utils/types/KeyPaths'

export default theme

// ThemeColors and ThemeShadows were originally handcrafted types.

// type ThemeColors = {
//   surface: {
//     default: string
//     sunken: string
//     raised: string
//     overlay: string
//   }
//   border: {
//     default: string
//     focused: string
//     subtle: string
//     input: string
//     disabled: string
//     brand: string
//     selected: string
//     danger: string
//     warning: string
//     success: string
//     discovery: string
//     information: string
//     accent: object
//   }
//   text: {
//     default: string
//     subtle: string
//     subtlest: string
//     disabled: string
//     inverse: string
//     brand: string
//     selected: string
//     danger: string
//     warning: object
//   }
//   background: {
//     blanket: {
//       default: string
//     }
//   }
// }
type ThemeColors = {
  scale: {
    gray: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    neutral: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '1000': string
      '1100': string
      '000': string
    }
    neutralAlpha: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '000': string
    }
    blue: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    teal: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    purple: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    green: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    yellow: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    red: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    orange: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
    magenta: {
      '100': string
      '200': string
      '300': string
      '400': string
      '500': string
      '600': string
      '700': string
      '800': string
      '900': string
      '000': string
    }
  }
  text: {
    default: string
    subtle: string
    subtlest: string
    disabled: string
    inverse: string
    brand: string
    selected: string
    danger: string
    success: string
    discovery: string
    information: string
    accent: {
      blue: {
        default: string
        bolder: string
      }
      red: {
        default: string
        bolder: string
      }
      orange: {
        default: string
        bolder: string
      }
      yellow: {
        default: string
        bolder: string
      }
      green: {
        default: string
        bolder: string
      }
      purple: {
        default: string
        bolder: string
      }
      teal: {
        default: string
        bolder: string
      }
      magenta: {
        default: string
        bolder: string
      }
      gray: {
        default: string
        bolder: string
      }
    }
    warning: {
      default: string
      inverse: string
    }
  }
  icon: {
    default: string
    subtle: string
    inverse: string
    disabled: string
    brand: string
    selected: string
    danger: string
    success: string
    discovery: string
    information: string
    accent: {
      blue: string
      red: string
      orange: string
      yellow: string
      green: string
      purple: string
      teal: string
      magenta: string
      gray: string
    }
    warning: {
      default: string
      inverse: string
    }
  }
  border: {
    default: string
    inverse: string
    focused: string
    input: string
    disabled: string
    brand: string
    selected: string
    danger: string
    warning: string
    success: string
    discovery: string
    information: string
    accent: {
      blue: string
      red: string
      orange: string
      yellow: string
      green: string
      purple: string
      teal: string
      magenta: string
      gray: string
    }
    table: {
      default: string
    }
  }
  background: {
    disabled: string
    accent: {
      blue: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      red: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      orange: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      yellow: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      green: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      teal: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      purple: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      magenta: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
      gray: {
        subtlest: string
        subtler: string
        subtle: string
        bolder: string
      }
    }
    inverse: {
      subtle: {
        default: string
        hovered: string
        pressed: string
      }
    }
    input: {
      default: string
      hovered: string
      pressed: string
    }
    neutral: {
      default: {
        default: string
        hovered: string
        pressed: string
      }
      subtle: {
        default: string
        hovered: string
        pressed: string
      }
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
    brand: {
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
    selected: {
      default: {
        default: string
        hovered: string
        pressed: string
      }
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
    danger: {
      default: {
        default: string
        hovered: string
        pressed: string
      }
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
    warning: {
      default: {
        default: string
        hovered: string
        pressed: string
      }
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
    success: {
      default: {
        default: string
        hovered: string
        pressed: string
      }
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
    discovery: {
      default: {
        default: string
        hovered: string
        pressed: string
      }
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
    information: {
      default: {
        default: string
        hovered: string
        pressed: string
      }
      bold: {
        default: string
        hovered: string
        pressed: string
      }
    }
  }
  blanket: {
    default: string
    selected: string
    danger: string
  }
  interaction: {
    hovered: string
    pressed: string
  }
  skeleton: {
    default: string
    subtle: string
  }
  link: {
    default: string
    pressed: string
  }
  chart: {
    brand: {
      '[default]': string
      hovered: string
    }
    neutral: {
      '[default]': string
      hovered: string
    }
    success: {
      '[default]': {
        '[default]': string
        hovered: string
      }
      bold: {
        '[default]': string
        hovered: string
      }
    }
    danger: {
      '[default]': {
        '[default]': string
        hovered: string
      }
      bold: {
        '[default]': string
        hovered: string
      }
    }
    warning: {
      '[default]': {
        '[default]': string
        hovered: string
      }
      bold: {
        '[default]': string
        hovered: string
      }
    }
    information: {
      '[default]': {
        '[default]': string
        hovered: string
      }
      bold: {
        '[default]': string
        hovered: string
      }
    }
    discovery: {
      '[default]': {
        '[default]': string
        hovered: string
      }
      bold: {
        '[default]': string
        hovered: string
      }
    }
    categorical: {
      '1': {
        '[default]': string
        hovered: string
      }
      '2': {
        '[default]': string
        hovered: string
      }
      '3': {
        '[default]': string
        hovered: string
      }
      '4': {
        '[default]': string
        hovered: string
      }
      '5': {
        '[default]': string
        hovered: string
      }
      '6': {
        '[default]': string
        hovered: string
      }
      '7': {
        '[default]': string
        hovered: string
      }
      '8': {
        '[default]': string
        hovered: string
      }
    }
    blue: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    red: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    orange: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    yellow: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    green: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    teal: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    purple: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    magenta: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
    gray: {
      bold: {
        '[default]': string
        hovered: string
      }
      bolder: {
        '[default]': string
        hovered: string
      }
      boldest: {
        '[default]': string
        hovered: string
      }
    }
  }
  palette: {
    Blue100: string
    Blue200: string
    Blue300: string
    Blue400: string
    Blue500: string
    Blue600: string
    Blue700: string
    Blue800: string
    Blue900: string
    Blue1000: string
    Red100: string
    Red200: string
    Red300: string
    Red400: string
    Red500: string
    Red600: string
    Red700: string
    Red800: string
    Red900: string
    Red1000: string
    Yellow100: string
    Yellow200: string
    Yellow300: string
    Yellow400: string
    Yellow500: string
    Yellow600: string
    Yellow700: string
    Yellow800: string
    Yellow900: string
    Yellow1000: string
    Green100: string
    Green200: string
    Green300: string
    Green400: string
    Green500: string
    Green600: string
    Green700: string
    Green800: string
    Green900: string
    Green1000: string
    Purple100: string
    Purple200: string
    Purple300: string
    Purple400: string
    Purple500: string
    Purple600: string
    Purple700: string
    Purple800: string
    Purple900: string
    Purple1000: string
    Teal100: string
    Teal200: string
    Teal300: string
    Teal400: string
    Teal500: string
    Teal600: string
    Teal700: string
    Teal800: string
    Teal900: string
    Teal1000: string
    Orange100: string
    Orange200: string
    Orange300: string
    Orange400: string
    Orange500: string
    Orange600: string
    Orange700: string
    Orange800: string
    Orange900: string
    Orange1000: string
    Magenta100: string
    Magenta200: string
    Magenta300: string
    Magenta400: string
    Magenta500: string
    Magenta600: string
    Magenta700: string
    Magenta800: string
    Magenta900: string
    Magenta1000: string
    Neutral0: string
    Neutral100: string
    Neutral100A: string
    Neutral200: string
    Neutral200A: string
    Neutral300: string
    Neutral300A: string
    Neutral400: string
    Neutral400A: string
    Neutral500: string
    Neutral500A: string
    Neutral600: string
    Neutral700: string
    Neutral800: string
    Neutral900: string
    Neutral1000: string
    Neutral1100: string
  }
  elevation: {
    surface: {
      default: {
        '[default]': string
        hovered: string
        pressed: string
      }
      sunken: string
      raised: {
        '[default]': string
        hovered: string
        pressed: string
      }
      overlay: {
        '[default]': string
        hovered: string
        pressed: string
      }
    }
    shadow: {
      raised: string
      overflow: {
        default: string
        spread: string
        perimeter: string
      }
      overlay: string
    }
  }
  shadows: {
    xs: string
    xxs: string
    md: string
    lg: string
  }
}
type ThemeShadows = {
  shadow: {
    elevation: {
      raised: string
      overlay: string
      overflow: {
        default: string
        spread: string
        perimeter: string
      }
    }
  }
}

export type ThemeColorPaths = KeyPaths<ThemeColors>
export type ThemeShadowPaths = KeyPaths<ThemeShadows>
